<template>
  <BaseTemplate>
    <div class="complete-user-register">
      <Title eng="COMPLETE" :jpn="t('登録完了')" />
      <div class="description">
        <span class="text">ご登録ありがとうございます。</span>
        <span class="text">オリパレットをお楽しみくださいませ！</span>
      </div>
      <OrangeGradationButton
        class="square-button"
        :text="t('TOPページへ')"
        @handleSquareBtnClick="goToUserLogin"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title.vue';
import OrangeGradationButton from '@/components/atoms/OrangeGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CompleteUserRegister',
  mixins: [t],

  beforeRouteLeave(to, from, next) {
    if (to.name === 'ConfirmUserRegister') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    Title,
    OrangeGradationButton,
  },

  methods: {
    goToUserLogin() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.complete-user-register{
  width: 100%;
  min-height: 100%;
  max-width: 1400px;
  padding: 70px 30px 0px;
  margin: 0px auto;
  text-align: center;
  .description{
    display: flex;
    flex-direction: column;
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    height: 113px;
    margin-top: 40px;
    .text{
      font-family: $notoSansJP;
      font-size: 16px;
      line-height: 1.6;
      color: #000;
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 40px auto 0px;
  }
}
</style>
